


























import Vue, { PropType } from "vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Rates from "@/components/Molecules/Rates/index.vue";
import CompanyLogo from "@/components/Atoms/CompanyLogo/index.vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Heading,
    Rates,
    CompanyLogo
  },
  props: {
    organizationName: {
      type: String as PropType<Props["organizationName"]>,
      required: true
    },
    organizationId: {
      type: Number as PropType<Props["organizationId"]>,
      required: true
    },
    organizationLogoImage: {
      type: String as PropType<Props["organizationLogoImage"]>,
      required: true
    },
    organizationRating: {
      type: Number as PropType<Props["organizationRating"]>,
      required: true
    },
    disabledClick: {
      type: Boolean as PropType<Props["disabledClick"]>,
      default: false
    }
  },
  methods: {
    clickOrganizationName() {
      if (this.disabledClick) return;

      const companyDetailRoute = this.$router.resolve({
        name: "CompanyDetail",
        params: { companyId: String(this.organizationId) }
      });
      window.open(companyDetailRoute.href, "_blank", "noopener");
    }
  }
});
